import ControlModel from "../../../models/secure/ControlModel";

const retrieveControls = async (context) => {
    let controlModel = new ControlModel();
    return controlModel.getAllControlSettings().then(res => {
        if(res.data && res.data.status == controlModel.STATUS_SUCCESS){
            context.commit('SET_CONTROLS', res.data.records);
        } else {
            context.commit('CLEAR_CONTROLS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: {controlCode: value, name: value}
const retrieveControllerDetails = async (context, payload) => {
    let controlModel = new ControlModel();
    return controlModel.getControlSettingDetails(payload).then(res => {
        if(res.data && res.data.status == controlModel.STATUS_SUCCESS){
            context.commit('SET_CONTROL', res.data.records);
        } else {
            context.commit('CLEAR_CONTROL');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

// Payload required: {id: value, name: value, description: value, controlCode: value, redirect: value, status: value, updatedBy: value, userId: value, sessionId: value}
const updateControllerStatus = async (context, payload) => {
    let controlModel = new ControlModel();
    return controlModel.updateControllerStatus(payload).then(res => {
        if(res.data && res.data.status == ControlModel.STATUS_SUCCESS){
            context.commit('SET_CONTROLLER_STATUS', res.data);
        } else {
            context.commit('CLEAR_CONTROLLER_STATUS');
        }
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

export {
    retrieveControls,
    retrieveControllerDetails,
    updateControllerStatus
}
